import React from 'react'
import styled from '@emotion/styled'
import { smoothScrollIntoView } from '@jelly/utils'

const JumpBarWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	position: sticky;
	top: 0;
	width: 100%;
	z-index: 100;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		height: 72px;
	}
`
const JumpToTextBar = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	align-items: center;
	background-color: ${({ theme }) => theme.colors.tertiary};
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	font-size: 0.875rem;
	height: 40px;
	letter-spacing: 2.33px;
	line-height: 21px;
	padding: 0.5rem 1rem;
	text-transform: uppercase;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		font-size: 1.2rem;
		height: inherit;
		letter-spacing: 3.5px;
		line-height: 31px;
		min-width: 140px;
		padding: 0 0 0 1.5rem;
		text-align: center;
		width: initial;
	}
`
const Triangle = styled.span`
	display: none;

	${({ theme }) => theme.MQ.M} {
		border-top: 36px solid ${({ theme }) => theme.colors.primary};
		border-bottom: 36px solid ${({ theme }) => theme.colors.primary};
		border-left: 36px solid ${({ theme }) => theme.colors.tertiary};
		display: block;
	}
`
const LinksBar = styled.div`
	${({ theme }) => theme.fonts.primaryMedium};
	align-items: center;
	background-color: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	font-size: 0.875rem;
	height: inherit;
	justify-content: flex-start;
	letter-spacing: 1.56px;
	line-height: 21px;
	list-style: none;
	padding: 1rem;
	width: 100%;

	a {
		border-bottom: 1px solid ${({ theme }) => theme.colors.white};
		color: ${({ theme }) => theme.colors.white};

		&:hover {
			border-bottom: 1px solid ${({ theme }) => theme.colors.secondary};
			color: ${({ theme }) => theme.colors.secondary};
		}
	}

	li {
		&:first-of-type {
			margin-right: 1rem;
		}
	}

	${({ theme }) => theme.MQ.M} {
		font-size: 1.2rem;
		justify-content: flex-start;
		letter-spacing: 2.33px;
		line-height: 31px;

		li {
			&:first-of-type {
				margin-left: 1rem;
				margin-right: 2rem;
			}
		}
	}
`

/**
 * JumpBar that takes in an array of objects containing the text and sectionId of each jump link
 * @param {Array} props.links :: array of objects containing the text and url of each jump link
 */
export function JumpBar({ links }) {
	return (
		<JumpBarWrapper>
			<JumpToTextBar>Jump To:</JumpToTextBar>
			<Triangle />
			<LinksBar>
				{links.map(({ text, jumpLink }, i) => (
					<li key={`${i}-${text}`}>
						<a
							href={jumpLink}
							onClick={(e) => {
								e.preventDefault()

								const targetElement = document.querySelector(e.currentTarget.getAttribute('href'))
								smoothScrollIntoView(targetElement)
							}}
						>
							{text}
						</a>
					</li>
				))}
			</LinksBar>
		</JumpBarWrapper>
	)
}
